import React, { useEffect, useRef } from "react";
import InputBase from "@mui/material/InputBase";
import clsx from "clsx";
import useClasses from "../../useClasses";

const styles = (theme) => ({
  root: {
    cursor: "default",
    borderRadius: theme.shape.borderRadius,
    border: "2px solid rgba(0,0,0,0)",
    textAlign: "left",
    width: "100%",
    paddingLeft: theme.spacing(1),
    //background: "rgba(0,0,0,0.05)"
  },
  labelRoot: {
    //background: theme.palette.grey[200],
    //border: "1px solid rgba(0, 0, 0, 0.2)",
  },
  focused: {
    border: "2px solid " + theme.palette.primary.dark,
    background: "rgba(255,255,255,1)",
  },
  error: { border: "2px solid " + theme.palette.secondary.dark },
  titleInput: {
    fontFamily: theme.typography.h4.fontFamily,
    fontWeight: theme.typography.h4.fontWeight,
    fontSize: theme.typography.h4.fontSize,
    lineHeight: theme.typography.h4.lineHeight,
    letterSpacing: theme.typography.h4.letterSpacing,
    color: theme.palette.text.primary,
  },
  descriptionInput: {
    fontFamily: theme.typography.body1.fontFamily,
    fontWeight: theme.typography.body1.fontWeight,
    fontSize: theme.typography.body1.fontSize,
    lineHeight: theme.typography.body1.lineHeight,
    letterSpacing: theme.typography.body1.letterSpacing,
    color: theme.palette.text.secondary,
  },
  labelInput: {
    fontFamily: theme.typography.body2.fontFamily,
    fontWeight: theme.typography.body2.fontWeight,
    fontSize: theme.typography.body2.fontSize,
    lineHeight: theme.typography.body2.lineHeight,
    letterSpacing: theme.typography.body2.letterSpacing,
    color: theme.palette.text.primary,
  },
  questionInput: {
    fontFamily: theme.typography.body1.fontFamily,
    fontWeight: theme.typography.body1.fontWeight,
    fontSize: theme.typography.body1.fontSize,
    lineHeight: theme.typography.body1.lineHeight,
    letterSpacing: theme.typography.body1.letterSpacing,
    color: theme.palette.text.primary,
  },
});

export default function InputField({
  type,
  inputValue,
  placeholder,
  onChange,
  autoFocus,
  isSelected,
  error = false,
  disabled = false,
  onKeyDown,
}) {
  const classes = useClasses(styles);
  const ref = useRef();

  const handleFocus = (event) => {
    event?.target?.select();
  };

  const getClassName = (type) => {
    switch (type) {
      case "title":
        return classes.titleInput;
      case "description":
        return classes.descriptionInput;
      case "question":
        return classes.questionInput;
      case "label":
        return classes.labelInput;
      default:
        return classes.questionInput;
    }
  };
  useEffect(() => {
    if (autoFocus && ref.current) {
      ref.current.focus();
      setTimeout(function () {
        handleFocus({ target: ref.current });
      }, 50); //select all text in any field on focus for easy re-entry. Delay sightly to allow focus to "stick" before selecting.
    }
  }, [autoFocus]);

  return (
    <InputBase
      inputRef={ref}
      classes={{
        root: clsx(classes.root, {
          [classes.labelRoot]: type === "label" && isSelected,
        }),
        focused: classes.focused,
        error: classes.error,
      }}
      //autoFocus={autoFocus}
      fullWidth
      multiline={["description", "question"].includes(type)}
      placeholder={placeholder}
      inputProps={{
        "aria-label": "overview",
        className: getClassName(type),
      }}
      onFocus={handleFocus}
      value={inputValue}
      onChange={onChange}
      error={error}
      required={type === "label"}
      disabled={disabled}
      onKeyDown={onKeyDown}
    />
  );
}
